import { useEffect, useState } from 'react';

import { CustomerGoHighLevelAccountInfo } from '../../../interfaces/goHighLevelAccount';

import { nutritionCustomerGhlContactService } from '../../../services/customerGhlContactService/nutritionCustomerGhlContactService';
import { scanIqCustomerGhlContactService } from '../../../services/customerGhlContactService/scanIqCustomerGhlContactService';
import { CustomerGhlContactService } from '../../../services/customerGhlContactService/customerGhlContactService';
import {
  CUSTOMER_TYPE,
  CustomerType,
} from '../../../../shared/constants/customer/customerType';

type UseCustomerGoHighLevelConnectionReturn = {
  accountInfo: CustomerGoHighLevelAccountInfo | undefined;
  refreshConnectionInfo: () => Promise<void>;
};

const serviceConfig: Record<CustomerType, CustomerGhlContactService> = {
  [CUSTOMER_TYPE.NUTRITION]: nutritionCustomerGhlContactService,
  [CUSTOMER_TYPE.SCAN_IQ]: scanIqCustomerGhlContactService,
};

export const useCustomerGoHighLevelConnection = (
  customerId: number,
  customerType: CustomerType,
  entityId?: number,
): UseCustomerGoHighLevelConnectionReturn => {
  const service = serviceConfig[customerType];

  const [accountInfo, setAccountInfo] = useState<
    CustomerGoHighLevelAccountInfo | undefined
  >(undefined);

  const getAccountInfo = async () => {
    const resp = await service.getConnectedAccountInfo(customerId, entityId);

    setAccountInfo(resp);
  };

  useEffect(() => {
    getAccountInfo();
  }, [customerId, customerType, entityId]);

  const refreshConnectionInfo = async () => {
    const resp = await service.refreshConnectionInfo(customerId, entityId);

    setAccountInfo(resp);
  };

  return {
    accountInfo,
    refreshConnectionInfo,
  };
};
